<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onMoveToArchive(close)">
			<div class="modal-header bg-info text-white py-2">
				<h1 class="modal-title fs-5">{{$t('header.exam-move-to-archive')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="alert alert-info">
					<div>{{formatDate(date, 'DD.MM.YYYY')}}</div>
					<div>{{name}}</div>
					<div>{{lang.toUpperCase()}}</div>
					<div>{{organization_shortname}}</div>
				</div>
				<div>{{$t('text.confirm-exam-move-to-archive')}}</div>
				<div class="m-t"><span style="color: #900;">{{$t('text.attention')}}</span> {{$t('text.warning.exam-move-to-archive')}}</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-info" :disabled="loading">{{$t('btn.move-to-archive')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		date: '',
		name: '',
		lang: '',
		organization_shortname: '',
		
		error: '',
		loading: false,
	}),
	methods: {
		formatDate: lib.formatDate,
		
		async onMoveToArchive(close){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doMoveExamToArchive(this.$vfm.modals[0].params._value.exam.id);
			if(ret.success){
				this.$emit('moveToArchive', close);
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	mounted(){
		this.date = this.$vfm.modals[0].params._value.exam.date;
		this.name = this.$vfm.modals[0].params._value.exam.name;
		this.lang = this.$vfm.modals[0].params._value.exam.lang;
		this.organization_shortname = this.$vfm.modals[0].params._value.exam.organization_shortname;
	},
}
</script>